import * as React from 'react';

var defaultValue = {
  type: 'static',
  hierarchy: 'primary',
  size: 'default',
  intent: 'generic'
};
var MarkerContext = /*#__PURE__*/React.createContext(defaultValue);
var useMarkerContext = function useMarkerContext() {
  var context = React.useContext(MarkerContext);
  return context;
};
var MarkerContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultValue : _ref$value;
  return /*#__PURE__*/React.createElement(MarkerContext.Provider, {
    value: value
  }, children);
});
MarkerContextProvider.displayName = 'MarkerContextProvider';

export { MarkerContextProvider, useMarkerContext };
//# sourceMappingURL=MarkerContext.js.map
